import { Button } from 'antd';
import React from 'react';
import { v4 as uuid } from 'uuid';
import { DownloadOutlined, DeleteOutlined } from '@ant-design/icons';

import { Carousel, ColourPicker, FormWrapper, Switch, Text } from '../../../WidgetConfiguratorComponents/FormGroups';

const RiskLevelsConfigurator = ({ viewblockState, setViewblockState }) => {
    const onUpdateThreatLimits = (updateThreatLimit, key, value) => {
        setViewblockState((prev) => ({
            ...prev,
            settings: {
                ...prev.settings,
                threatLimits: prev.settings.threatLimits.map((threatLimit) => {
                    if (threatLimit === updateThreatLimit) {
                        return {
                            ...threatLimit,
                            [key]: value,
                        };
                    } else {
                        return threatLimit;
                    }
                }),
            },
        }));
    };

    const onAddAppearanceGroup = () => {
        setViewblockState((prev) => ({
            ...prev,
            settings: {
                ...prev.settings,
                threatLimits: [
                    ...prev.settings.threatLimits,
                    {
                        id: uuid(),
                        label: '',
                        showValue: false,
                        backgroundColor: '#ffffff',
                    },
                ],
            },
        }));
    };

    const onDeleteAppearanceGroup = (deleteThreatLimit) => {
        setViewblockState((prev) => ({
            ...prev,
            settings: {
                ...prev.settings,
                threatLimits: prev.settings.threatLimits.filter((threatLimit) => threatLimit !== deleteThreatLimit),
                limits: prev.settings.limits.filter((limit) => limit.threatLimitId !== deleteThreatLimit.id),
            },
        }));
    };

    return (
        <FormWrapper>
            <Carousel label='Appearance' addItem={onAddAppearanceGroup}>
                {viewblockState.settings.threatLimits.map((threatLimit) => (
                    <React.Fragment key={threatLimit.id}>
                        <Text label='Id' value={threatLimit.id} disabled={true} />
                        <Text label='Name' value={threatLimit.label} onChange={(label) => onUpdateThreatLimits(threatLimit, 'label', label)} />
                        <Switch
                            label='Display values'
                            value={threatLimit.showValue}
                            onChange={(showValue) => onUpdateThreatLimits(threatLimit, 'showValue', showValue)}
                        />
                        <ColourPicker
                            value={threatLimit.backgroundColor}
                            onChange={(backgroundColor) => onUpdateThreatLimits(threatLimit, 'backgroundColor', backgroundColor)}
                        />
                        <div style={{ gridColumn: '1 / 6', gridRow: 7, textAlign: 'center' }}>
                            <Button onClick={() => onDeleteAppearanceGroup(threatLimit)} danger icon={<DeleteOutlined />}>
                                Delete
                            </Button>
                        </div>
                    </React.Fragment>
                ))}
            </Carousel>
        </FormWrapper>
    );
};

export default RiskLevelsConfigurator;
